import React, { useState, useEffect } from "react";
import { Button, Dialog, DialogContent, IconButton, TextField, Typography, InputLabel, MenuItem, Select, FormControl, Stack, } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const AttendanceConfigModal = ({ onClose, fetchData, propData }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [time, setTime] = useState("");
  const [color, setColor] = useState("#000000");

  useEffect(() => {
    if (propData) {
      setName(propData?.name || "");
      setTime(propData?.time || "");
      setColor(propData?.color || "#000000");
    }
  }, [propData]);

  const submitHandler = async () => {
    if (!name.trim()) {
      window.NotificationUtils.showError("Please fill the Name");
      return;
    }
    if (!time.trim()) {
      window.NotificationUtils.showError("Please fill the Time");
      return;
    }
    if (!color.trim()) {
      window.NotificationUtils.showError("Please select a Color");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        name: name.trim(),
        time: time.trim(),
        color: color.trim()
      };
      if (propData) {
        await window.Platform.database.updateAttendanceConfig({
          ...payload,
          id: propData.id,
        });
        window.NotificationUtils.showSuccess("Update successfully");
      } else {
        let result = await window.Platform.database.addAttendanceConfig(payload);
        window.NotificationUtils.showSuccess(result?.message);
      }
      setName("");
      setTime("");
      setColor("#000000");
      fetchData();
      onClose();
    } catch (err) {
      window.NotificationUtils.showError(err?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog disableEnforceFocus maxWidth="sm" fullWidth open>
      <StyledDialogContent>
        <ModalHeaderContainer>
          <Typography variant="h5">{propData ? "Edit" : "Add New"} Attendance Configuration</Typography>
          <IconButton onClick={onClose}>
            <CloseOutlined />
          </IconButton>
        </ModalHeaderContainer>

        {loading && <OpaqueLoading />}

        <Stack gap={2} padding={2}>
          <FormControl fullWidth>
            <TextField
              label="Name"
              value={name}
              type="text"
              onChange={(e) => setName(e.target.value.replace(/^\s+/, ""))}
              fullWidth
            />
          </FormControl>
          <FormControl fullWidth>
            <TextField
              label="Time"
              value={time}
              type="time"
              inputProps={{ step: 1 }} // allows HH:MM:SS
              onChange={(e) => setTime(e.target.value)}
              fullWidth
            />
          </FormControl>
          <FormControl fullWidth>
            <InputLabel shrink>Color</InputLabel>
            <input
              type="color"
              value={color}
              onChange={(e) => setColor(e.target.value)}
              style={{ width: "100%", height: 40, border: "none", background: "none" }}
            />
          </FormControl>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button
              color="primary"
              variant="contained"
              onClick={submitHandler}
              disabled={!name || !time || !color}
            >
              {propData ? 'Update' : 'Create'}
            </Button>
          </div>
        </Stack>
      </StyledDialogContent>
    </Dialog>
  );
};

export default AttendanceConfigModal;
